import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c6a012a2&scoped=true&"
import script from "./subjectMarks.js?vue&type=script&lang=js&"
export * from "./subjectMarks.js?vue&type=script&lang=js&"
import style0 from "./scoped.css?vue&type=style&index=0&id=c6a012a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6a012a2",
  null
  
)

export default component.exports